@for (item of supplements; track item.id + (item.mainProductId ?? '')) {
  <div class="row list-item no-gutters">
    <div class="row w-100 no-gutters no-wrap">
      <div class="d-flex">
        @if (item.image) {
          <div class="img-thumbnail">
            <img width="56" height="56" [ngSrc]="item.image | plysResize: 56 : 56" [alt]="item.name" />
          </div>
        }
        <div>
          <h3>
            <span class="mr-2">{{ item.name }}</span>
            @if (isMenuVisible(item) && menuUrl$ | async; as url) {
              <a [href]="url" target="_blank" class="menu desktop">
                <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
                {{ 'global.menu' | transloco }}
              </a>
            }
          </h3>
          <div>
            <strong class="text-md pr-2">{{ item.price | localeCurrency: item.currency }}</strong>
            @if (item.priceBefore) {
              <small class="price-discounted pr-2">{{ item.priceBefore | localeCurrency: item.currency }}</small>
            }
          </div>
          <ng-container
            *ngTemplateOutlet="
              productDescription;
              context: { description: item.description, id: item.id, extraClass: 'desktop' }
            "
          ></ng-container>
          @if (item.allergens) {
            <plys-allergen-list class="desktop" [allergens]="item.allergens" [open]="false"></plys-allergen-list>
          }
        </div>
      </div>
      <div class="col-5 col-md-4 mt-3 quantity-control-container">
        @if (hasOptions(item)) {
          @if ((canAddMore(item) | async) === true) {
            <plys-options-quantity [product]="item" (add)="openOptions(item, supplements)"></plys-options-quantity>
          }
        } @else if (item?.isLimitedToMainProduct) {
          @let limit = limitOf(item) | async;
          <plys-quantity-control
            #limitedControl
            [value]="getItemQuantity(item.id) | async"
            [addLabel]="'product_options.add' | transloco"
            [addTestId]="'add-' + item.name"
            [soldOutLabel]="item.soldOut ? ('product_options.sold_out' | transloco) : null"
            (increased)="addToCart(item, supplements, limitedControl)"
            (decreased)="removeFromCart(item.id)"
            [disabled]="limit?.canAddMore !== true"
            [matTooltip]="'supplements.you_can_select_max' | transloco: { number: limit?.max }"
            [matTooltipDisabled]="limit?.canAddMore !== false"
            matTooltipPosition="above"
            matTooltipClass="max-quantity-tooltip"
            [useLoading]="true"
            [displayLoading]="reserving$ | async"
          >
            @if (isMenuVisible(item) && menuUrl$ | async; as url) {
              <a [href]="url" target="_blank" class="menu mobile-flex">
                <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
              </a>
            }
          </plys-quantity-control>
        } @else {
          <plys-quantity-control
            #control
            [value]="getItemQuantity(item.id) | async"
            [addLabel]="'product_options.add' | transloco"
            [addTestId]="'add-' + item.name"
            [soldOutLabel]="item.soldOut ? ('product_options.sold_out' | transloco) : null"
            (increased)="addToCart(item, supplements, control)"
            (decreased)="removeFromCart(item.id)"
            [useLoading]="true"
            [displayLoading]="reserving$ | async"
          >
            @if (isMenuVisible(item) && menuUrl$ | async; as url) {
              <a [href]="url" target="_blank" class="menu mobile-flex">
                <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
              </a>
            }
          </plys-quantity-control>
        }
      </div>
    </div>
    @if (item.allergens) {
      <plys-allergen-list class="w-100 mobile" [allergens]="item.allergens" [open]="false"></plys-allergen-list>
    }
    @if (hasOptions(item)) {
      <plys-configured-items
        class="w-100"
        [product]="item"
        [parentProductId]="item.mainProductId"
        [siblings]="supplements"
      ></plys-configured-items>
    }
    <div>
      <ng-container
        *ngTemplateOutlet="
          productDescription;
          context: { description: item.description, id: item.id, extraClass: 'mobile' }
        "
      ></ng-container>
    </div>
  </div>
}
<ng-template
  #productDescription
  let-description="description"
  let-id="id"
  let-childId="childId"
  let-extraClass="extraClass"
>
  @if (isExpanded(id, childId)) {
    <div class="description" [ngClass]="extraClass">
      {{ description }}
    </div>
  }
  @if (description) {
    <p class="read-details" [ngClass]="extraClass" (click)="toggleDetails(id, childId)">
      {{ 'global.read_details' | transloco }}
      <span
        [class.expanded]="isExpanded(id, childId)"
        class="read-details-icon"
        [inlineSVG]="'/assets/icons/icon-chevron-down-thick.svg'"
      ></span>
    </p>
  }
</ng-template>
